import { createFirebaseClient } from '@giftsay/firebase/client';
import { getFirestore } from 'firebase/firestore';

export const { app, auth, googleProvider, storage } = createFirebaseClient({
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
});

// Only used for the live new-order bell (see features/orders/hooks/use-order-signals.ts) — every
// other read goes through the API.
export const firestore = getFirestore(app);
